import React from 'react';
import CategoryTemplate from "../../components/templates/CategoryTemplate";
import {useParams} from "react-router-dom";

export const CategoryShow = () => {
    const {id} = useParams<{ id: string }>();
    const numId = Number(id);
    return <CategoryTemplate type={'EDIT'} targetId={numId}/>
};
